import { LOCALITY_PAGE } from '@/constants/urls';
import { useRouter } from '@/hooks/useRouter';

export const useIsLocalityPage = (): { isLocalityPage: boolean } => {
  const router = useRouter();
  return { isLocalityPage: router.pathname.startsWith(LOCALITY_PAGE) };
};
